import { Injectable } from '@angular/core';
import { BaseFiltrableItemService } from '@common-modules/shared/charts/base-filtrable-item.service';
import { DateHelperService } from '@common-modules/shared/helpers/date-helper.service';
import {
  ISerieDataPointDto,
  SerieDataPointDto,
} from '@common-modules/shared/model/chart/serie-data-point.dto';
import { IFiltrableItemQueryDto } from '@common-modules/shared/model/filtrable-items/filtrable-item-query.dto';
import { FiltrableItemTypeEnum } from '@common-modules/shared/model/filtrable-items/types/filtrable-item-type-enum';
import { EventChartQueryDto } from '@common-modules/wlm-charts/core/events-chart/models/events-chart-query.dto';
import { asEnumerable } from 'linq-es2015';

import { CTAttributeResult, CTResultFiltrableItemDto, CTResultFiltrableItemQueryDto, CTResultFiltrableType } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/ct-result-filtrable-item';
import { CtResult } from '@cloud-twin-v2/ct-map/models/ct-result';

@Injectable({
  providedIn: 'root',
})
export class ResultsFiltrableItemService extends BaseFiltrableItemService {
  readonly type: FiltrableItemTypeEnum = FiltrableItemTypeEnum.CTResult;

  constructor(private readonly _dateHelperService: DateHelperService) {
    super();
  }

  setDateRange(filtrableItem: CTResultFiltrableItemDto, startDate: Date, endDate: Date): void {
    filtrableItem.startDate = startDate;
    filtrableItem.endDate = endDate;
  }

  getQuery(filtrableItem: CTResultFiltrableItemDto): IFiltrableItemQueryDto {
    const { startDate, endDate, filtrableType } = filtrableItem;

    return new CTResultFiltrableItemQueryDto(
      new Date(startDate),
      this._dateHelperService.addDays(new Date(endDate), 1),
      '',
      filtrableItem.filtrableType.networkElementId,
      filtrableItem.filtrableType.attributeId,
      filtrableItem.filtrableType.workspaceConnectSetting.scenarioId
    );
  }

  getDataPoints(
    filtrableType: CTResultFiltrableType,
    data: CtResult
  ): ISerieDataPointDto[] {
    const serieDataPoints = this.mapCTResultToCTAttributeResult(data, filtrableType);

    var dataPoints = Object.keys(serieDataPoints.values).map(
      (p) =>
        new SerieDataPointDto(
          filtrableType.key,
          p,
          +serieDataPoints.values[p],
          false,
          false,
          0,
          false
        )
    );

    return dataPoints;
  }

  getEventQuery(filtrableItem: CTResultFiltrableItemDto): EventChartQueryDto {
    return null;
  }

  private mapCTResultToCTAttributeResult(ctResult: CtResult, filtrableType: CTResultFiltrableType): CTAttributeResult {

    var neIdAttributes = asEnumerable(ctResult.networkElements)
      .FirstOrDefault(x => x.networkElementId === filtrableType.networkElementId);

    var attributeResults = asEnumerable(neIdAttributes.attributes).FirstOrDefault(x => x.name === filtrableType.attributeId);

    return new CTAttributeResult({
      scenarioId: ctResult.scenarioId,
      networkElementId: neIdAttributes.networkElementId,
      networkElementName: neIdAttributes.networkElementName,
      attributeName: attributeResults.name,
      values: attributeResults.values,
      unitLabel: 'attributeResults.unitLabel'
    });
  }
}
